var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgInfoGreyFilled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99316 0C4.12376 0 0.986328 3.13438 0.986328 7C0.986328 10.8656 4.12376 14 7.99316 14C11.8626 14 15 10.8656 15 7C15 3.13438 11.8626 0 7.99316 0Z",
    fill: "#A9ADB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24365 4.25C7.24365 4.44891 7.32276 4.63968 7.46357 4.78033C7.60437 4.92098 7.79535 5 7.99448 5C8.19362 5 8.38459 4.92098 8.5254 4.78033C8.66621 4.63968 8.74531 4.44891 8.74531 4.25C8.74531 4.05109 8.66621 3.86032 8.5254 3.71967C8.38459 3.57902 8.19362 3.5 7.99448 3.5C7.79535 3.5 7.60437 3.57902 7.46357 3.71967C7.32276 3.86032 7.24365 4.05109 7.24365 4.25ZM8.3699 6H7.61907C7.55024 6 7.49393 6.05625 7.49393 6.125V10.375C7.49393 10.4437 7.55024 10.5 7.61907 10.5H8.3699C8.43872 10.5 8.49504 10.4437 8.49504 10.375V6.125C8.49504 6.05625 8.43872 6 8.3699 6Z",
    fill: "#FAFAFA"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfoGreyFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info-grey-filled.c998d592.svg";
export { ForwardRef as ReactComponent };